import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyD25Q0d5lym5OobPSuuLs_WVt8_c8DB21c",
  authDomain: "www.resmeet.co.za",
  projectId: "resmeet-db7b9",
  storageBucket: "resmeet-db7b9.firebasestorage.app",
  messagingSenderId: "198942034407",
  appId: "1:198942034407:web:e1809831c3ab7f32959542"
};

if(process.env.NODE_ENV === 'development') window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

const app = initializeApp(firebaseConfig);

initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LcerNksAAAAAF5UoTTtDa2YNTs5cN2O6j5MP46A'),
  isTokenAutoRefreshEnabled: true // maintains session
});

// initialize other services
const db = getFirestore(app);
const auth = getAuth(app);

export {db, auth };